import React from 'react';
import { motion } from 'framer-motion';

const ContactSection = () => {
  return (
    <div style={{ 
      padding: "50px 0", 
      background: "linear-gradient(90deg, #333, #000)", 
      color: "white", 
      textAlign: "center",
      fontFamily: "'Plus Jakarta Sans', sans-serif",
      width: "100%",
      paddingBottom: "50px"
    }}>
      <motion.div
        whileHover={{ scale: 1.5 }}
        whileTap={{ scale: 0.98 }}
        style={{
          padding: "0px 0",
        }}
      >
        <h2 style={{ fontSize: "14px", marginBottom: "10px" }}>Reach out for more information</h2>
        <p style={{ fontSize: "12px", color: "#FFD700", fontWeight: "bold" }}>uif@gmail.com</p>
        <p style={{ fontSize: "10px", marginTop:10, color: "#FFD700", fontWeight: "bold" }}>© 2024 UIF</p>

      </motion.div>
    </div>
  );
};

export default ContactSection;
